class CustomPdpViewMore extends HTMLElement {
  constructor() {
    super();
    this.viewMoreButton = null;
    this.handleViewMoreClick = this.handleViewMoreClick.bind(this);
    this.mediaElements = null;
    this.hiddenClassName = null;
  }

  connectedCallback() {
    this.viewMoreButton = this.querySelector('#js-product-view-more-btn');
    this.mediaElements = document.querySelectorAll('[data-media-element]');
    this.hiddenClassName =
      this.getAttribute('data-hidden-class') || 'hidden-desktop';

    if (this.viewMoreButton) {
      this.viewMoreButton.addEventListener('click', this.handleViewMoreClick);
      this.viewMoreButton.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleViewMoreClick();
        }
      });
    }
  }

  disconnectedCallback() {
    if (this.viewMoreButton) {
      this.viewMoreButton.removeEventListener(
        'click',
        this.handleViewMoreClick,
      );
      this.viewMoreButton.removeEventListener(
        'keydown',
        this.handleViewMoreClick,
      );
    }
  }

  handleViewMoreClick() {
    const event = new CustomEvent('pdpViewMoreClicked', {
      bubbles: true,
      composed: true,
    });

    this.dispatchEvent(event);
    this.handleRemoveClassHiddenOnMediaElement();
    this.handleHideViewMoreButton();
  }

  handleHideViewMoreButton() {
    if (this.viewMoreButton) {
      this.classList.add(this.hiddenClassName);
    }
  }

  handleRemoveClassHiddenOnMediaElement() {
    if (!this.mediaElements) {
      return;
    }

    this.mediaElements.forEach((element) => {
      if (element.classList.contains(this.hiddenClassName)) {
        element.classList.remove(this.hiddenClassName);
      }
    });
  }
}

customElements.define('custom-pdp-view-more', CustomPdpViewMore);
